import { RouteObject } from 'react-router-dom'
import { LoadedPageContent } from '$components/common'
import { default as Payroll } from '.'

const basePath = '/time/payroll'
export const payrollRoutes: RouteObject[] = [
  {
    path: `${basePath}/payruns`,
    element: (
      <LoadedPageContent title={'Payruns'} displayLeftTitle={false}>
        <Payroll.Payruns.Component />
      </LoadedPageContent>
    ),
    loader: Payroll.Payruns.Loader,
  },
  {
    path: `${basePath}/payruns/:payrunId`,
    element: (
      <LoadedPageContent title={'Edit Payrun'} displayLeftTitle={false}>
        <Payroll.Payruns.Edit.Component />
      </LoadedPageContent>
    ),
    loader: Payroll.Payruns.Edit.Loader,
  },
]
